
import { connect } from 'react-redux'
import { compose, withProps, withState, withHandlers } from 'recompose'

// Component pieces
import mapDispatchToProps from './mapDispatchToProps'
import mapStateToProps from './mapStateToProps'
import props from './props'
import renderer from './renderer'
import handlers from './handlers'

const CompanySettingsComponent = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props),
  withHandlers(handlers)
)(renderer)

export default CompanySettingsComponent
